module.exports = __webpack_public_path__ + "static/media/Developmenticon03.155b5f35.png";